import { render, staticRenderFns } from "./PlanAndAssign.vue?vue&type=template&id=718a93c8&scoped=true&"
import script from "./PlanAndAssign.vue?vue&type=script&lang=js&"
export * from "./PlanAndAssign.vue?vue&type=script&lang=js&"
import style0 from "./PlanAndAssign.vue?vue&type=style&index=0&id=718a93c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "718a93c8",
  null
  
)

export default component.exports